


















































import {Component, Vue} from 'vue-property-decorator';
import VueElementLoading from 'vue-element-loading';
import store from "@/services/store";
import DatePicker from "vue2-datepicker";
import moment from 'moment';


@Component({
    components: {
        'loading': VueElementLoading,
        DatePicker
    }
})
export default class PurchasePlan extends Vue {
    private region = '00';
    beg_date = new Date();
    end_date = new Date();

    private visible = true;
    private fields = [
        {
            key: 'date',
            label: 'Дата',
        }

    ]

    private count_data = []

    setVisible(vis: boolean) {
        this.visible = vis
    }

    async load_data() {
        const response = await fetch('/rust-api/get-realm-users-login');
        const result = await response.json();
        this.count_data = result.data;
        for (const col of result.columns) {
            const field = {
                key: col,
                label: col,
                tdClass: "text-right"
            }
            this.fields.push(field)
        }
    }

    load_report() {
        const url = `/rust-api/get-realm-users-login-between/${moment(this.beg_date).format('YYYY-MM-DD')}/${moment(this.end_date).format('YYYY-MM-DD')}`;
        window.location.assign(url);
    }

    mounted() {
        this.region = store.state._instanceCode;
        this.load_data();
        this.beg_date = new Date();
        this.beg_date.setDate(this.end_date.getDate()-5);
    }

}
